import request from '../request';

export default {
  // 城市-列表
  lists(data) {
    return request.get('/adminRegion/index', data);
  },

  // 城市-添加
  add(data) {
    return request.post('/adminRegion/create', data);
  },

  // 城市-编辑
  edit(data) {
    return request.post('/adminRegion/update', data);
  },

  // 城市-删除
  delete(data) {
    return request.post('/adminRegion/delete', data);
  },

  adminRegionLists(data) {
    return request.get('/adminRegion/lists', data);
  },

  getAllList(data) {
    return request.get('/adminRegion/getAllList', data);
  },
};
